import { createService } from './service';
import { SignalRSymbol } from './symbols';

export const VueSignalR = {
  install(app, options) {
    const service = createService(options);
    app[SignalRSymbol] = service;
  },
};
